import { render, staticRenderFns } from "./StcvPD_ItemsRaw.vue?vue&type=template&id=36343438"
import script from "./StcvPD_ItemsRaw.vue?vue&type=script&lang=js"
export * from "./StcvPD_ItemsRaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports